export default __webpack_public_path__ + "static/media/virti-light-small.9b8922d0.svg";